module.exports = __webpack_public_path__ + "img/safari_tips_en.85e1af86.png";